import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";

const testimonies = [
    {
        name: "John F.",
        comment: "Pelayanan sangat memuaskan! Mobil bersih dan nyaman. Proses pemesanan juga cepat.",
        rating: 5,
    },
    {
        name: "Siti N.",
        comment: "Sangat membantu saat liburan keluarga. Terima kasih!",
        rating: 4,
    },
    {
        name: "Bayu W.",
        comment: "Harga terjangkau, unit tersedia banyak pilihan, recommended banget!",
        rating: 5,
    },
];

function TestimoniSection() {
    const { t, i18n } = useTranslation();

    return (
        <section id="testimoni" className="py-16 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 text-center">
                <h2 className="text-3xl font-bold mb-8">
                    {t('the_said_about_us')}
                </h2>
                <div className="grid md:grid-cols-3 gap-6">
                    {testimonies.map((item, i) => (
                        <div
                            key={i}
                            className="bg-white rounded-2xl p-6 shadow hover:shadow-lg transition duration-300"
                        >
                            <div className="flex justify-center mb-2 text-yellow-400">
                                {Array.from({ length: item.rating }).map((_, idx) => (
                                    <Star key={idx} className="w-5 h-5 fill-yellow-400" />
                                ))}
                            </div>
                            <p className="italic text-gray-700 mb-4">"{item.comment}"</p>
                            <p className="font-semibold text-gray-900">- {item.name}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default TestimoniSection;
